import { useState } from "react";
import { Divider, Box, styled, Container, Grid } from "@mui/material";
import ChatSidebarAdmin from "./ChatSidebar";
import ChatContentAdmin from "./ChatContent";
import ChatMsgSentAdmin from "./ChatMsgSent";
import AppCard from "../shared/AppCard";
import Breadcrumb from "../shared/Breadcrumb";
import BackButton from "../BackButton/BackButton";

const SectionWrapper = styled("section")(({ theme }) => ({
  minHeight: "calc(100vh - 64px)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: theme.palette.background.default,
  "& h4,h6": {
    color: theme.palette.text.primary,
    fontWeight: 700,
  },
}));
function ChatsAdmin() {
  const [isMobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [chatupdate, setChatupdate] = useState(false);

  const onChatUpdate = () => setChatupdate(!chatupdate);

  return (
    <SectionWrapper>
      <Container maxWidth="">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2} mt={0} sx={{ justifyContent: "center" }}>
            <Grid item xs={12} className="chatApp">
              <BackButton />
              <Breadcrumb title="Chat app" subtitle="Messenger" />

              <AppCard>
                {/* ------------------------------------------- */}
                {/* Left part */}
                {/* ------------------------------------------- */}

                <ChatSidebarAdmin isMobileSidebarOpen={isMobileSidebarOpen} onSidebarClose={() => setMobileSidebarOpen(false)} />
                {/* ------------------------------------------- */}
                {/* Right part */}
                {/* ------------------------------------------- */}

                <Box flexGrow={1}>
                  <ChatContentAdmin chatupdate={chatupdate} toggleChatSidebar={() => setMobileSidebarOpen(true)} />
                  <Divider />
                  <ChatMsgSentAdmin onChatUpdate={onChatUpdate} />
                </Box>
              </AppCard>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </SectionWrapper>
  );
}

export default ChatsAdmin;
